import * as Inputs from './inputs';
import * as Buttons from './buttons';
import * as Cards from './card';

export default {
  ...Inputs,
  ...Buttons,
  ...Cards,
};